export default "__VITE_ASSET__BSvjFhe3__"